import {logoutUser} from "../actions/session";

const NUMERIC_REGEX = /[0-9]/;
const EMAIL_REGEX = /(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i
export const REQUIRED_FIELD_ERROR = 'This field is required.';


export function isDev() {
  return process.env.NODE_ENV === 'development';
}

export function checkResponseError(errorObject) {
  return errorObject.apiError === 'SUCCESS'
}

export async function dispatchError(error, onDispatch, dispatch) {
  await (error.message === 'logout-user') ? dispatch(logoutUser()) : dispatch(onDispatch);
}

export async function extractSessionIdFromResponse(response){
  return (Array.isArray(response)) ? response[0].loggedInUserSessionId : (response.loggedInUserSessionId) ? response.loggedInUserSessionId : response.user.loggedInUserSessionId;
}

export function validateRequired(value) {
  return (value);
}

export function validateNonNumeric(value) {
  return !value.match(NUMERIC_REGEX);
}

export function validateEmail(value) {
  const formattedEmail = value.trim().toLowerCase();

  return formattedEmail.match(EMAIL_REGEX);
}